<div class="message-recipient-status" [class.has-popover]="showChoicesPopover">
  <div class="choices-popover" *ngIf="showChoicesPopover">
    <div class="popover-label">{{ "COMPONENTS.MESSAGE_RECIPIENT_STATUS.CHOICES" | translate }}</div>
    <div class="popover-choices">
      <div
        class="popover-choice"
        *ngFor="let choice of choices"
        [class.selected]="choice.id === selectedChoiceId"
      >
        <mat-icon *ngIf="choice.id === selectedChoiceId">check</mat-icon>
        <span>{{ choice.choice_text }}</span>
      </div>
    </div>
    <div class="no-response" *ngIf="selectedChoiceId === null">
      {{ "COMPONENTS.MESSAGE_RECIPIENT_STATUS.NO_RESPONSE" | translate }}
    </div>
  </div>

  <div class="recipient-content">
    <div class="avatar-container">
      <app-avatar-thumbnail
        [user]="messageRecipient.recipient"
        [size]="28"
      ></app-avatar-thumbnail>
    </div>

    <span class="recipient-name">
      {{ messageRecipient.recipient.first_name }} {{ messageRecipient.recipient.last_name }}
    </span>

    <div
      class="revoke"
      *ngIf="
        messageRecipient.status === 'pending' ||
        messageRecipient.status === 'unread' ||
        messageRecipient.status === 'delivered'
      "
    >
      <button
        mat-icon-button
        class="revoke-button"
        *ngIf="messageRecipient.recipient.is_active"
        (click)="revoke(messageRecipient)"
        [disabled]="revoking"
        [matTooltip]="'COMPONENTS.MESSAGE_RECIPIENT_STATUS.REVOKE' | translate"
        [attr.aria-label]="'COMPONENTS.MESSAGE_RECIPIENT_STATUS.REVOKE' | translate"
      >
        <mat-icon>cancel_schedule_send</mat-icon>
      </button>
    </div>

    <div
      class="status"
      [ngClass]="
        {
          read: 'read',
          pending: 'pending',
          delivered: 'delivered',
          revoked: 'revoked'
        }[messageRecipient.status]
      "
    >
      {{ messageRecipient.status }}
    </div>
  </div>
</div>
